import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    // 渲染导航
    navView(list = []) {
        return list.map((item, index) => (
            <li key={index}>
                <a href={item.url} target="_blank" rel={relText}>
                    {item.title}
                </a>
            </li>
        ));
    }
    render() {
        if (this.props.content) {
            return (
                <div className={classnames(styles.nav_box, 'nav_box')} id="navigation">
                    <ul className={classnames(styles.nav, 'clearfix', 'nav')}>{this.navView(this.props.content)}</ul>
                </div>
            );
        } else {
            return null;
        }
    }
}

export { Nav };
export default Nav;
